<template>
  <span
    data-cy="import-status-chip"
    :class="[
      'inline-flex h-6 shrink-0 items-center whitespace-nowrap rounded-full px-3 text-xs font-medium',
      chip.class
    ]"
  >
    {{ chip.label }}
  </span>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { type ImportStatus, STATUS_CHIPS } from "@/DataImports/importsHubRows";

const props = defineProps<{ status: ImportStatus }>();

// An unrecognised status renders itself rather than claiming a state the server did not report.
const chip = computed(
  () =>
    STATUS_CHIPS[props.status] ?? {
      label: props.status,
      class: "bg-gray-100 text-gray-600"
    }
);
</script>
